import { pageLabel } from "./analyticsPages";
import { displayPath, isStoreOrigin, parsePageUrl } from "./contextAttributes";

// A pagina de uma mensagem: o `current_page_url` do primeiro bloco `context`
// que o tem. O valor vem do browser do visitante, portanto nada aqui assume
// forma: um render que levante em branco o backoffice inteiro (nao ha
// ErrorBoundary), por isso tudo o que nao for o esperado cai em null.
const pageOfMessage = (message, storeOrigins) => {
  const blocks = Array.isArray(message?.blocks) ? message.blocks : [];
  for (const block of blocks) {
    if (block?.type !== "context") continue;
    const page = parsePageUrl(block.payload?.current_page_url, storeOrigins);
    if (page) return page;
  }
  return null;
};

// Origem mais caminho em minusculas, sem um `index.php`, `index.html` ou
// `index.htm` no fim (com uma barra final ou sem ela) e sem uma barra final,
// como o cartao das paginas conta (`/carrinho/index.php/` e `/carrinho/` sao a
// mesma). As origens do chat contam como uma so, como no cartao, que junta os
// hosts do chat: `www.radiopopular.pt/carrinho` e `radiopopular.pt/carrinho` sao
// a mesma pagina. Uma origem de fora compara-se pela sua. Nunca a query nem o
// fragmento: um filtro novo na listagem nao e outra pagina, e comparar o href
// inteiro marcava uma mudanca a cada clique num filtro.
const pageKey = (url, storeOrigins) => {
  const pathname = url.pathname
    .toLowerCase()
    .replace(/\/index\.(php|html?)\/?$/, "/")
    .replace(/\/$/, "");
  return `${isStoreOrigin(url, storeOrigins) ? "loja" : url.origin.toLowerCase()}${pathname}`;
};

/**
 * Uma entrada por turno, alinhada com `turns`: `{ href, label }` quando o turno
 * do cliente esta noutra pagina que a ultima marcada, senao null. A pagina de
 * um turno e a da primeira mensagem dele que a tem; um turno sem pagina nao
 * mexe na ultima. O `href` e o URL inteiro da mensagem que marca; o rotulo e o
 * caminho dela sem a query nem o fragmento, descodificado como no cartao das
 * paginas (`pageLabel`), com o host a frente fora das origens do chat.
 */
export const pageMarkers = (turns, storeOrigins) => {
  if (!Array.isArray(turns)) return [];
  let lastKey = null;
  return turns.map((turn) => {
    if (turn?.role !== "user" || !Array.isArray(turn.items)) return null;
    let page = null;
    for (const message of turn.items) {
      page = pageOfMessage(message, storeOrigins);
      if (page) break;
    }
    if (!page) return null;
    const url = new URL(page.href);
    const key = pageKey(url, storeOrigins);
    if (key === lastKey) return null;
    lastKey = key;
    return { href: page.href, label: pageLabel(displayPath(url, storeOrigins)) };
  });
};
